import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function ProtectedRoute({ children, adminOnly = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-loading">
                <div className="text-sm text-muted-foreground">Loading…</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }
    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
}
